import { defineStore } from 'pinia';
import { GetPayUMethodsOutput } from '~/composables';
import { PayuMethodCodesEnum } from '~/helpers/payuMethods';
import getPayUMethodsGql from '~/modules/GraphQL/customQueries/getPayUMethods.gql';

interface PayuMethod {
  name: string;
  brandImageUrl: string;
  status: string;
  value: string;
  sort: number;
}

interface PayuMethodsState {
  payuMethods: PayuMethod[] | null;
}

export const usePayuMethodsStore = defineStore('payuMethods', {
  state: (): PayuMethodsState => ({
    payuMethods: null,
  }),
  actions: {
    async loadPayuMethods() {
      if (this.payuMethods && this.payuMethods.length > 0) return;
      const { data } = (await this.$nuxt.app.$vsf.$magento.api.customQuery({
        query: getPayUMethodsGql,
        queryVariables: {
          input: {
            code: PayuMethodCodesEnum.PAYU_GATEWAY,
          },
        },
      })) as { data: GetPayUMethodsOutput };
      if (!data || !data?.getPayUMethods) return;
      const availableMethods = data?.getPayUMethods
        .filter((method) => method.status === 'ENABLED')
        .sort((a, b) => a.sort - b.sort);
      this.payuMethods = availableMethods;
    },
  },
});
